import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import DarkButton from "../../Global/DarkButton";
import Colors from "../../Global/colors";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      // width: "49ch",
      padding: 5,
      textAlign: "center",
    },
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

export default function RightSideText({
  status,
  site,
  priority,
  handleActionData,
  actionData,
  userList,
  users,
  groups,
  currentUser,
  handleEditDes,
  handleDelete,
}) {
  const { t } = useTranslation();
  const classes = useStyles();

  const history = useHistory();

  console.log("Groups>>>>>>>>>>>>>>>>>>", groups);

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <Grid
        container
        alignItems="center"
        justify="center"
        style={{ margin: 0 }}
      >
        <Grid
          container
          alignItems="center"
          justify="center"
          style={{ margin: 0 }}
        >
          <Grid item xs={12}>
            <div
              className="textarea "
              style={{ width: "100%", padding: "10px 5px" }}
            >
              {" "}
              <TextField
                size="small"
                id="outlined-basic"
                className="outlined-basic"
                label="Title"
                name="title"
                placeholder="Title"
                value={actionData.title}
                onChange={handleActionData}
                variant="outlined"
                fullWidth
                disabled
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div
              className="textarea"
              style={{
                width: "100%",
                borderColor: "whitesmokey",
                padding: "10px 5px 0 5px",
              }}
            >
              <TextField
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={4}
                defaultValue="Default Value"
                variant="outlined"
                value={actionData.description}
                placeholder="Description"
                onChange={handleActionData}
                name="description"
                fullWidth
              />
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            align="right"
            style={{ padding: " 10px 5px 0 5px" }}
          >
            <Button
              variant="contained"
              className="addBtn"
              style={{ backgroundColor: Colors.globalColor8, width: "100%" }}
              size="small"
              onClick={handleEditDes}
            >
              Save
            </Button>
          </Grid>
        </Grid>

        <Grid item xs={12} style={{ padding: "10px 0" }}>
          <FormControl
            style={{ width: "100%", padding: 5 }}
            size="small"
            variant="outlined"
          >
            <Select
              style={{ width: "100%" }}
              defaultValue={actionData.status}
              onChange={handleActionData}
              name="status"
              displayEmpty
              fullWidth
              className={classes.selectEmpty}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {status.map((v) => {
                return <MenuItem value={v}>{v}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} style={{padding:'5px'}}>
          <Autocomplete size="small" fullWidth options={site} classes={{ option: classes.option }} style={{ width: "100%" }} autoHighlight onChange={(e, value) => handleActionData(value, "site")} name="site" value={actionData.site?.id ? actionData.site : site?.filter((v) => actionData.site === v.id)[0] ? { title: site?.filter((v) => actionData.site === v.id)[0].title, id: site?.filter((v) => actionData.site === v.id)[0].id } : null} getOptionLabel={(option) => option.title} renderOption={(option) => <React.Fragment>
                {option.title}
              </React.Fragment>} renderInput={(params) => <TextField {...params} label={t("Site")} name="site" fullWidth style={{ width: "100%" }} variant="outlined" inputProps={{ ...params.inputProps }} />} disabled={actionData.created_by !== currentUser.user_id} />
        </Grid>

        <Grid item xs={12} style={{ padding: "5px" }}>
          <Autocomplete
            size="small"
            id="country-select-demoss"
            fullWidth
            options={users}
            style={{ width: "100%", padding: "10px 0" }}
            autoHighlight
            getOptionLabel={(option) =>
              `${option?.first_name} ${option?.last_name}`
            }
            renderOption={(option) => (
              <React.Fragment>
                {option.first_name} {option.last_name}
              </React.Fragment>
            )}
            multiple
            onChange={(e, value) => handleActionData(value, "user_id")}
            value={actionData.Users}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("Assignees")}
                fullWidth
                variant="outlined"
                inputProps={{ ...params.inputProps }}
              />
            )}
            disabled={actionData.created_by !== currentUser.user_id}
          />
        </Grid>

        <Grid item xs={12} style={{ padding: "0px 5px" }}>
          <Autocomplete
            size="small"
            id="country-select-demoss"
            fullWidth
            options={groups  || []}
            style={{ width: "100%", padding: "10px 0" }}
            autoHighlight
            getOptionLabel={(option) => `${option?.group_name}`}
            renderOption={(option) => (
              <React.Fragment>{option.group_name}</React.Fragment>
            )}
            multiple
            onChange={(e, value) => handleActionData(value, "group_ids")}
            value={actionData?.group_ids || []}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("Groups")}
                fullWidth
                variant="outlined"
                inputProps={{ ...params.inputProps }}
              />
            )}
            disabled={actionData.created_by !== currentUser.user_id}
          />
        </Grid>

        <Grid item xs={12} style={{ padding: "5px" }}>
          <Autocomplete
            size="small"
            id="country-select-demo"
            style={{ width: "100%" }}
            options={priority}
            classes={{ option: classes.option }}
            fullWidth
            name="priority"
            autoHighlight
            value={
              actionData.priority 
            }
            getOptionLabel={(option) => option}
            renderOption={(option) => <React.Fragment>{option}</React.Fragment>}
            onChange={(e, value) => handleActionData(value, "priority")}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("Priority")}
                variant="outlined"
                fullWidth
                style={{ width: "100%" }}
                inputProps={{ ...params.inputProps }}
              />
            )}
            disabled={actionData.created_by !== currentUser.user_id}
          />
        </Grid>

        <Grid item xs={12} style={{ padding: "5px" }}>
          <FormControl fullWidth>
            <TextField
              size="small"
              id="datetime-local"
              label={t("Due Date")}
              type="datetime-local"
              defaultValue={new Date()}
              style={{ padding: "10px 0" }}
              variant="outlined"
              fullWidth
              value={actionData.due}
              name="due"
              onChange={handleActionData}
              InputLabelProps={{ shrink: true }}
              disabled={actionData.created_by !== currentUser.user_id}
            />
          </FormControl>
        </Grid>
      </Grid>
    </form>
  );
}
